import React, {useState, useEffect} from "react";
import {FieldState, FormField} from "../../lib/forms";
import {InputProps} from "components/forms/Input";
import {IonCheckbox, IonItem, IonLabel} from "@ionic/react";


interface CheckboxProps extends InputProps {
  options: any[],
}

export const Checkbox = (props:CheckboxProps) => {
  const [fieldDef, setFieldDef] = useState<FormField>(props.definition);
  const [fieldState, setFieldState] = useState<FieldState>(props.state);
  const [selected, setSelected] = useState<string[]>(props.state.value || []);
  const fieldName = props.definition.name;

  useEffect(() => {
    // console.log(`RESET STATE: ${fieldName}`, props.state);
    setFieldState(props.state);
  }, [props.state, fieldName]);

  useEffect(() => {
    // console.log(`RESET DEF: ${fieldName}`);
    setFieldDef(props.definition);
  }, [props.definition, fieldName]);

  const onChange = (e:any) => {
    // console.log('CHECKBOX onChange', e.detail);
    const checked = e.detail.checked;

    let _selected: string[];
    if (checked) {
      _selected = [...selected, e.detail.value];
    } else {
      _selected = selected.filter((i: string) => i !== e.detail.value);
    }
    setSelected(_selected);
    props.onChange(fieldDef.name, e.detail);
  };

  return (
    <div className="mb-4 mt-4">
      <div className={`pl-4 ${(fieldState.touched && fieldState.hasError) && "text-red-600"}`}>
        {fieldDef.label} {fieldDef.required && '*'}
      </div>
      <div className="pl-4">
        {
          props.options.map(i => {
            const checked = selected.findIndex((j: any) => j === i) !== -1;

            return (
              <CheckboxItem
                key={`${fieldDef.name}-${i}`}
                value={i}
                checked={checked}
                onChange={onChange}
                disabled={props.disabled}
              />
            )
          })
        }
      </div>
    </div>
  );
};

const CheckboxItem = ({value, checked, onChange, disabled}: {value: string, checked: boolean, onChange: (e: any) => void, disabled?: boolean}) => {
  return (
    <IonItem disabled={disabled}>
      <IonLabel>{value}</IonLabel>
      <IonCheckbox slot="end"
                   value={value}
                   onIonChange={onChange}
                   checked={checked}
      />
    </IonItem>
  )
}
